import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  live: (params = {}) => client.get("/vessels/live", { params }).then((r) => r.data),
  vessel: (mmsi) => client.get(`/vessels/${mmsi}`).then((r) => r.data),
  track: (mmsi, from, to) =>
    client.get(`/vessels/${mmsi}/track`, { params: { from, to } }).then((r) => r.data),
  search: (q) => client.get("/vessels/search", { params: { q } }).then((r) => r.data),
  snapshot: (t, bbox) => client.get("/snapshot", { params: { t, bbox } }).then((r) => r.data),
  health: () => client.get("/health").then((r) => r.data),
  getSettings: () => client.get("/settings").then((r) => r.data),
  putSettings: (s) => client.put("/settings", s).then((r) => r.data),
  restartWorker: () => client.post("/worker/restart").then((r) => r.data),
  infrastructure: (params = {}) => client.get("/infrastructure", { params }).then((r) => r.data),
  infrastructureDetail: (id) => client.get(`/infrastructure/${id}`).then((r) => r.data),
  refreshInfrastructure: () => client.post("/infrastructure/refresh").then((r) => r.data),
  slicks: (params = {}) => client.get("/slicks", { params }).then((r) => r.data),
  slickAlerts: (params = {}) => client.get("/slicks/alerts", { params }).then((r) => r.data),
  pilotState: () => client.get("/pilot/state").then((r) => r.data),
  pilotIncidents: (params = {}) => client.get("/pilot/incidents", { params }).then((r) => r.data),
  pilotIncident: (id) => client.get(`/pilot/incidents/${id}`).then((r) => r.data),
  pilotReport: (id) => client.get(`/pilot/incidents/${id}/report`).then((r) => r.data),
  pilotToggle: (on) => client.post("/pilot/toggle", { on }).then((r) => r.data),
  pilotRun: () => client.post("/pilot/run").then((r) => r.data),
  slickDetail: (id) => client.get(`/slicks/${id}`).then((r) => r.data),
  slickCorrelate: (id, params = {}) => client.get(`/slicks/${id}/correlate`, { params }).then((r) => r.data),
  refreshSlicks: (body = {}) => client.post("/slicks/refresh", body).then((r) => r.data),
};

export default api;
